/// <reference path="../../../typings/tsd.d.ts" /> 
module warsApp.directives {
    export interface IGisMapScope extends angular.IScope {
        mapConfiguration: Wars.Domain.Model.Gis.MapConfiguration;
        mapId: string;
    }

    export class GisMap implements IDirective {
        constructor() {

        }

        public templateUrl = "./app/views/directives/gis/gisMap.html";
        public restrict: string = "E";
        public controller = ["$scope", '$rootScope', GisMapController];
        public controllerAs = "controller";
        public scope: any = {
            mapConfiguration: "=",
            mapId: "="
        };


        public link($scope: IApiGridScope, element: JQuery, attrs: ng.IAttributes) {
            $scope.$on("$destroy",
                () => {
                    GisMapController.currentMap = null;
                    console.log(this.controller);
                });
        }
    }

    export class GisMapController {
        public map: L.Map;
        public static currentMap: L.Map;

        constructor(private $scope: IGisMapScope, private $rootScope: angular.IRootScopeService) {
            console.log($scope.mapId);

            this.map = L.map('PreviewMap', <any>{ editable: true,fullscreenControl: true }).setView([
                    $scope.mapConfiguration.centerX,
                    $scope.mapConfiguration.centerY
                ],
                $scope.mapConfiguration.defaultZoom);

            //this.setUpLayers();
            this.setUpLegend(this.map);

            GisMapController.currentMap = this.map;
            $rootScope.$broadcast('mapLoaded');
            console.log(GisMapController.currentMap);
        }

        private setUpLegend(map: L.Map) {
            let legend = Enumerable.from(this.$scope.mapConfiguration.legendConfigurations)
                .singleOrDefault(l => l.isDefault);

            if (legend) {
                var options: any = {};

                options.position = this.getPosition(legend.displayCornerLocation);
                options.sortLayers = true;
                var layersControl = L.control.layers(null, null, options);
                layersControl.addTo(map);

                Enumerable.from(legend.legendLayers).orderBy(l => l.isDefault).toArray().forEach(l => {
                    var leafletLayer=this.addLayer(l.layer);
                    let name = l.name;
                    if (l.displayHtml) {
                        name = l.displayHtml;
                    }

                    if (l.layer.type === Wars.Domain.Model.Codes.Enums.LayerType.TileLayer ||
                        l.layer.type === Wars.Domain.Model.Codes.Enums.LayerType.EsriBaseMap ||
                        l.layer.type === Wars.Domain.Model.Codes.Enums.LayerType.EsriVectorBaseMap) {
                        map.eachLayer(layer => {
                            if ((<any>layer).warsId === l.layer.id) {
                                layersControl.addBaseLayer(layer, name);
                            }
                        });
                    }

                    if (!l.isDefault) {
                        this.map.removeLayer(leafletLayer);
                    }
                });
            }
        }

        private getPosition(position: Wars.Domain.Model.Codes.DisplayCornerLocation): string {
            switch (position) {
            case Wars.Domain.Model.Codes.DisplayCornerLocation.BottomLeft:
                return "bottomleft";
            case Wars.Domain.Model.Codes.DisplayCornerLocation.BottomRight:
                return "bottomright";
            case Wars.Domain.Model.Codes.DisplayCornerLocation.TopLeft:
                return "topleft";
            case Wars.Domain.Model.Codes.DisplayCornerLocation.TopRight:
                return "topright";
            }
        }


        private setUpLayers() {
            this.$scope.mapConfiguration.layers.forEach(l => {
                this.addLayer(l);
            });
        }

        private addLayer(l: Wars.Domain.Model.Gis.Layer) {
            switch (l.type) {
            case Wars.Domain.Model.Codes.Enums.LayerType.TileLayer:
                return this.addTileLayer(l);
            case Wars.Domain.Model.Codes.Enums.LayerType.EsriBaseMap:
                return this.addEsriBaseMap(l);
            case Wars.Domain.Model.Codes.Enums.LayerType.EsriVectorBaseMap:
                return this.addEsriVector(l);
            }
        }

        private addTileLayer(layer: Wars.Domain.Model.Gis.Layer) {
            L.tileLayer(layer.url,
                {
                    attribution: layer.attribution,
                    maxZoom: layer.maxZoom,
                    id: layer.id
                }).addTo(this.map);
        }

        private addEsriBaseMap(layer: Wars.Domain.Model.Gis.Layer) {
            let l = (<any>L).esri.basemapLayer(layer.esriLayerName);
            l.warsId = layer.id;
            l.addTo(this.map);

            return l;
        }

        private addEsriVector(layer: Wars.Domain.Model.Gis.Layer) {
            let l = (<any>L).esri.Vector.basemap(layer.esriLayerName);
            l.warsId = layer.id;
            l.addTo(this.map);

            return l;
        }

    }
}

warsApp.registerDirective('GisMap', []);